/* eslint-disable no-throw-literal */

'use strict'

const data = require('./data.json')
const _ = require('lodash')
const util = require('util')

const trigramSequences = {
  earlierHeaven: [1, 6, 4, 5, 2, 3, 7, 8],
  laterHeaven: [7, 2, 8, 1, 4, 5, 3, 6]
}

const hoQue = [
  { quai: ['䷀', '䷫', '䷠', '䷋', '䷓', '䷖', '䷢', '䷍'], ho: '䷀' },
  { quai: ['䷹', '䷮', '䷬', '䷞', '䷦', '䷎', '䷽', '䷵'], ho: '䷹' },
  { quai: ['䷝', '䷷', '䷱', '䷿', '䷃', '䷺', '䷅', '䷌'], ho: '䷝' },
  { quai: ['䷲', '䷏', '䷧', '䷟', '䷭', '䷯', '䷛', '䷐'], ho: '䷲' },
  { quai: ['䷸', '䷈', '䷤', '䷩', '䷘', '䷔', '䷚', '䷑'], ho: '䷸' },
  { quai: ['䷜', '䷻', '䷂', '䷾', '䷰', '䷶', '䷣', '䷆'], ho: '䷜' },
  { quai: ['䷳', '䷕', '䷙', '䷨', '䷥', '䷉', '䷼', '䷴'], ho: '䷳' },
  { quai: ['䷁', '䷗', '䷒', '䷊', '䷡', '䷪', '䷄', '䷇'], ho: '䷁' }
]

const getThuTuTrongHo = (character) => {
  for (var i = 0; i < hoQue.length; i++) {
    var ho = hoQue[i].quai
    var hoIndex = ho.indexOf(character)
    if (hoIndex !== -1) return hoIndex
  }
  return -1
}

const getTheUng = (character) => {
  var hoIndex = getThuTuTrongHo(character)
  var the, ung
  switch (hoIndex) {
    case -1:
      break
    case 0:
      the = 6
      break
    case 1:
      the = 5
      break
    case 2:
      the = 4
      break
    case 3:
      the = 3
      break
    case 4:
      the = 2
      break
    case 5:
      the = 1
      break
    case 6:
      the = 2
      break
    case 7:
      the = 3
      break
  }
  ung = (the + 3) % 6
  return { the, ung }
}

const diaChi = ['Tý', 'Sửu', 'Dần', 'Mão', 'Thìn', 'Tị', 'Ngọ', 'Mùi', 'Thân', 'Dậu', 'Tuất', 'Hợi']
const diaChiNguHanh = [3, 1, 4, 4, 1, 5, 5, 1, 2, 2, 1, 3]
const nguHanh = ['Thổ', 'Kim', 'Thuỷ', 'Mộc', 'Hoả']

const getLucThan = (diachiNguHanh, hexagramNguHanh) => {
  switch (diachiNguHanh - hexagramNguHanh) {
    case 0:
      return 'Huynh đệ'
    case -1:
    case 4:
      return 'Phụ mẫu'
    case -2:
    case 3:
      return 'Quan quỷ'
    case 1:
    case -4:
      return 'Tử tôn'
    case 2:
    case -3:
      return 'Thê tài'
  }
}

const iChing = {}
module.exports = {
  iChing,
  diaChi,
  diaChiNguHanh,
  nguHanh
}

class Trigram {
  constructor (number) {
    assertValidTrigramNumber(number)
    _.forOwn(data.trigrams[number - 1], (value, key) => {
      this[key] = value
    })
  }

  hexagrams (position) {
    if (position && !position === 'top' && !position === 'bottom') {
      throw new RangeError('position must be "top", "bottom", or undefined')
    }

    return _.filter(iChing.hexagrams, (h) => {
      return (h.topTrigram.number === this.number && (!position || position === 'top')) ||
        (h.bottomTrigram.number === this.number && (!position || position === 'bottom'))
    })
  }
}

class Change {
  constructor (from, to) {
    if (!(from instanceof Hexagram)) {
      assertValidHexagramNumber(from)
      from = iChing.hexagram(from)
    }
    this.from = from

    if (!(to instanceof Hexagram)) {
      assertValidHexagramNumber(to)
      to = iChing.hexagram(to)
    }
    this.to = {
      ...to,
      lucthan: to.nguhanhIndex.map((diaChiNguHanh) => {
        return getLucThan(diaChiNguHanh, from.hoQue.nguhanh)
      }),
      phucThanLucThan: to.phucthan ? to.phucthan.map((diachi) => {
        if (!diachi) return diachi
        const index = diaChi.indexOf(diachi)
        const nguHanhIndex = diaChiNguHanh[index]
        const lucThan = getLucThan(nguHanhIndex, from.hoQue.nguhanh)
        return lucThan.split(' ')[0]
      }) : null
    }

    const changeValue = parseInt(from.binary, 2) ^ parseInt(to.binary, 2) // xor
    this.binary = toBinaryString(changeValue)
    this.changingLines = _.map(this.binary, (char) => {
      return parseInt(char)
    }).reverse()
  }
}

class Hexagram {
  constructor (number) {
    assertValidHexagramNumber(number)
    _.forOwn(data.hexagrams[number - 1], (value, key) => {
      if (key === 'topTrigram') {
        this.topTrigram = iChing.trigram(value)
      } else if (key === 'bottomTrigram') {
        this.bottomTrigram = iChing.trigram(value)
      } else if (key === 'lines') {
        this[key] = value
      } else {
        this[key] = value
      }
    })
    this.the = getTheUng(this.character).the
    this.ung = getTheUng(this.character).ung
    this.lucthan = 'lucthan'
    this.diachi = [...this.topTrigram.chi.up, ...this.bottomTrigram.chi.down]
    this.thiencan = [this.topTrigram.can.up, this.topTrigram.can.up, this.topTrigram.can.up, this.bottomTrigram.can.down, this.bottomTrigram.can.down, this.bottomTrigram.can.down]
    this.nguhanhIndex = this.diachi.map((chi) => {
      const index = diaChi.indexOf(chi)
      return diaChiNguHanh[index]
    })
    this.colorNguHanh = this.nguhanhIndex.map((index) => {
      return `color_${index}`
    })
    this.nguhanh = this.nguhanhIndex.map((index) => nguHanh[index - 1])
    if (this.topTrigram.number === this.bottomTrigram.number) {
      this.hoQue = this.topTrigram
    } else {
      const parent = _.find(data.hexagrams, (h) => h.number === this.parent)
      this.hoQue = data.trigrams[parent.topTrigram - 1]
    }
    this.hoQueName = this.hoQue.names.toString()
    this.lucthan = this.nguhanhIndex.map((diaChiNguHanh) => {
      return getLucThan(diaChiNguHanh, this.hoQue.nguhanh)
    })
    this.phucThanNguHanh = []
    this.phucThanLucThan = this.phucthan ? this.phucthan.map((diachi) => {
      if (!diachi) {
        this.phucThanNguHanh.push(diachi)
        return diachi
      }
      const index = diaChi.indexOf(diachi)
      const nguHanhIndex = diaChiNguHanh[index]
      this.phucThanNguHanh.push(nguHanhIndex)
      const lucThan = getLucThan(nguHanhIndex, this.hoQue.nguhanh)
      return lucThan.split(' ')[0]
    }) : null
    this.refinedLines = _.clone(this.lines).reverse()
    const isHaoTheDuong = this.refinedLines[this.the] === 1
    if (isHaoTheDuong) {
      this.quaithan = diaChi[1 + (5 - this.the) - 1] // khoi tu ti
    } else {
      this.quaithan = diaChi[7 + (5 - this.the) - 1] // khoi tu ngo
    }
  }

  changeTo (number) {
    assertValidHexagramNumber(number)
    if (this.number === number) {
      return null
    }
    const h2 = iChing.hexagram(number)
    return new Change(this, h2)
  }

  changeLines (lines) {
    if (!_.isArray(lines) || lines.length !== 6) {
      throw new RangeError('lines argument must be an array of 6 zeros and ones representing chaning lines')
    }

    // find the binary of the other hexagram
    let otherBinary = ''
    // reverse the lines to process the most significant bit first
    // so that otherBinary string concatenation has MSB at the beginning of the string
    const changingLines = lines.reverse()
    const thisLines = _.clone(this.lines).reverse()
    _.forEach(thisLines, (l, i) => {
      if (!_.isInteger(l) || l < 0 || l > 1) {
        throw new RangeError('lines argument must be an array of 6 zeros and ones representing chaning lines')
      }
      otherBinary += (l ^ changingLines[i]).toString() // xor
    })

    // if (otherBinary === this.binary) {
    //   // no change
    //   return null
    // }

    const otherHexagram = _.find(iChing.hexagrams, (h) => {
      return h.binary === otherBinary
    })

    return new Change(this.number, otherHexagram.number)
  }

  get changes () {
    if (!this._changes) {
      this._changes = _(_.range(1, 65))
        .map((h2) => {
          return new Change(this, h2)
        }).remove((c, i, a) => {
          return (c.binary !== '000000') // remove hexagram change to itself
        }).value()
    }
    return this._changes
  }
}

function initialize () {
  iChing.trigram = function trigram (number) {
    assertValidTrigramNumber(number)
    return iChing.trigrams[number - 1]
  }

  iChing.trigramSequence = function trigramSequence (name) {
    if (!_.has(trigramSequences, name)) {
      const names = _.map(trigramSequences, (s, name) => { return name })
      throw new RangeError('name must be a trigram sequence name: ' + names.join(', '))
    }

    const seq = trigramSequences[name]
    return _.map(seq, (number) => {
      return iChing.trigram(number)
    })
  }

  iChing.hexagram = function hexagram (number) {
    assertValidHexagramNumber(number)
    return iChing.hexagrams[number - 1]
  }

  iChing.trigrams = _.map(_.range(1, 9), (n) => {
    return new Trigram(n)
  })

  iChing.hexagrams = _.map(_.range(1, 65), (n) => {
    return new Hexagram(n)
  })

  iChing.findHexagram = function findHexagram (lines) {
    return _.find(iChing.hexagrams, (h) => {
      return _.isEqual(h.lines, lines)
    })
  }

  iChing.asGraph = function asGraph () {
    if (iChing._graph) {
      return iChing._graph
    }

    const graph = {
      nodes: [],
      edges: []
    }

    // iterate trigrams
    _.forEach(iChing.trigrams, (t) => {
      // create trigram node
      graph.nodes.push({
        id: 't' + t.number,
        type: 'trigram',
        name: t.character,
        number: t.number
      })
    })

    // iterate hexagrams
    _.forEach(iChing.hexagrams, (h) => {
      const id = 'h' + h.number

      // create hexagram node
      graph.nodes.push({
        id: id,
        type: 'hexagram',
        name: h.character,
        number: h.number
      })

      // create an edge to the bottom trigram
      graph.edges.push({
        id: util.format('%s-t%d-bottom', id, h.bottomTrigram.number),
        from: id,
        to: 't' + h.bottomTrigram.number,
        name: 'bottom'
      })

      // create an edge to the top trigram
      graph.edges.push({
        id: util.format('%s-t%d-top', id, h.topTrigram.number),
        from: id,
        to: 't' + h.topTrigram.number,
        name: 'top'
      })

      const changes = h.changes

      // iterate changes
      _.forEach(changes, (c) => {
        // create an edge to each change hexagram
        graph.edges.push({
          id: id + '-h' + c.to.number,
          from: id,
          to: 'h' + c.to.number,
          name: c.binary
        })
      })
    })

    iChing._graph = graph
    return graph
  }
}

function assertValidTrigramNumber (number) {
  if (!_.isInteger(number) || number < 1 || number > 8) {
    throw new RangeError('number must be an integer between 1 and 8')
  }
}

function assertValidHexagramNumber (number) {
  if (!_.isInteger(number) || number < 1 || number > 64) {
    throw new RangeError('number must be an integer between 1 and 64')
  }
}

function toBinaryString (i) {
  return pad((i >>> 0).toString(2), 6)
}

function pad (num, size) {
  var s = num.toString()
  while (s.length < size) s = '0' + s
  return s
}

initialize()
